<template>
    <div>
      <!-- Top bar -->
      <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="text-operations"></div>
  
      <!-- Header -->
      <div class="panel-head">
        <h3>Generación de reporte de Entradas a Lote</h3>
        <img src="@/assets/filtros.png" alt="filtros" />
      </div>
  
      <!-- Filters (form => Enter submits) -->
      <form
        class="filters-card"
        @submit.prevent="handleSubmit"
        @keydown.enter.prevent="handleSubmit"
      >
        <!-- Fecha de entrada -->
        <div class="row">
          <label>Fecha de entrada</label>
          <input type="date" v-model="lotStartDateStart" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep">al</span>
          <input type="date" v-model="lotStartDateEnd" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
        </div>
  
        <!-- Fecha de salida -->
        <div class="row">
          <label>Fecha de salida</label>
          <input type="date" v-model="lotEndDateStart" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep">al</span>
          <input type="date" v-model="lotEndDateEnd" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
        </div>
  
        <!-- Número de orden -->
        <div class="row">
          <label for="note_number_start">Número de orden</label>
          <input id="note_number_start" type="text" v-model="noteNumberStart" placeholder="Inicio" />
          <span class="sep">al</span>
          <input id="note_number_end" type="text" v-model="noteNumberEnd" placeholder="Fin" />
        </div>
  
        <!-- Lote -->
        <div class="row">
          <label for="lot">Lote</label>
          <select id="lot" class="form-select" v-model="lot">
            <option v-for="opt in $catalogs.lotes" :key="opt" :value="opt">{{ opt }}</option>
          </select>
          <span class="sep"></span>
          <div class="cell"></div>
        </div>
  
        <!-- Sucursal (full width) -->
        <div class="row">
          <label for="sucursal">Sucursal</label>
          <select id="sucursal" v-model="sucursal" class="form-select span-3" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
            <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
          </select>
        </div>
  
        <!-- Placas -->
        <div class="row">
          <label for="vehicle_plates">Placas</label>
          <input id="vehicle_plates" type="text" v-model="vehiclePlates" placeholder="Placas del vehículo" />
          <span class="sep"></span>
          <div class="cell"></div>
        </div>
  
        <!-- Marca / Submarca -->
        <div class="row">
          <label for="vehicle_brand">Marca</label>
          <select id="vehicle_brand" class="form-select" v-model="SelectedBrand" @change="FetchFilteredSubBrands" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
            <option v-for="(brandPk, brandName) in brands" :key="brandPk" :value="brandPk">
              {{ brandName }}
            </option>
          </select>
          <span class="sep"></span>
          <select id="vehicle_subbrand" class="form-select"
                  v-model="SelectedSubBrand"
                  :disabled="blockEdit || subBrandLoading"
                  :class="{ 'grayed-out': blockEdit, 'sub-brand-loading-grayed-out': subBrandLoading }">
            <option v-for="(subId, subLabel) in sub_brands" :key="subId" :value="subId">
              {{ subLabel }}
            </option>
          </select>
        </div>
  
        <!-- Color -->
        <div class="row">
          <label for="vehicle_color">Color</label>
          <input id="vehicle_color" type="text" v-model="vehicleColor" placeholder="Color" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep"></span>
          <div class="cell"></div>
        </div>
  
        <!-- Expediente -->
        <div class="row">
          <label for="file_number">Expediente</label>
          <input id="file_number" type="text" v-model="fileNumber" placeholder="Expediente" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep"></span>
          <div class="cell"></div>
        </div>
  
        <!-- Autoridad -->
        <div class="row">
          <label for="lot_authority">Autoridad</label>
          <select id="lot_authority" class="form-select" v-model="lotAuthority">
            <option v-for="opt in $catalogs.autoridades" :key="opt" :value="opt">{{ opt }}</option>
          </select>
          <span class="sep"></span>
          <div class="cell"></div>
        </div>
  
        <!-- Actions -->
        <div class="row actions">
          <div class="cell span-4">
            <button type="submit" class="btn-submit-save" :disabled="isGeneratingReport">
              {{ isGeneratingReport ? 'Generando reporte...' : 'Generar reporte' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </template>
  
  <style scoped>
  /* Top bar (kept) */
  .nav-bar-operations {
    position: absolute; top: 0; left: 0; width: 100%; height: 10vh;
    background-color: #FFC434; z-index: 1000; margin: 0;
  }
  .logo-button { position: absolute; height: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer; margin: 0; }
  .text-operations { margin-top: 10vh; width: 100%; height: 5vh; border-bottom: 1px solid #000; background: #fff; }
  
  .panel-head { margin: 10px 8px 6px; display: flex; align-items: center; gap: 8px; }
  .panel-head h3 { font-size: 1.15rem; margin: 0; }
  .panel-head img { width: 24px; height: 24px; }
  
  /* Filters card */
  .filters-card{
    --label-w: 200px;
    --ctrl-w: 360px;
    --sep-w: 22px;
    --gap: 8px;
    --h: 36px;
    --fs: 14px;
    --fs-small: 12px;
    --pad-x: 10px;
    --radius: 10px;
  
    margin: 10px 8px 16px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 12px;
    padding: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,.06);
    display: grid; gap: 10px;
  }
  .filters-card .row{
    display: grid;
    grid-template-columns: var(--label-w) var(--ctrl-w) var(--sep-w) var(--ctrl-w);
    align-items: center;
    gap: var(--gap);
  }
  .filters-card .row.actions { grid-template-columns: 1fr; }
  .filters-card .row-rel { position: relative; }
  .filters-card label { font-size: var(--fs); color:#222; white-space: nowrap; }
  .filters-card .sep { text-align: center; color:#666; font-size: var(--fs-small); }
  
  .filters-card input[type="text"],
  .filters-card input[type="date"],
  .filters-card select{
    height: var(--h);
    padding: 0 var(--pad-x);
    border: 1px solid #d5d5d5;
    border-radius: var(--radius);
    font-size: var(--fs);
    outline: none; width: 100%;
  }
  .filters-card input:focus, .filters-card select:focus{
    border-color:#b3b3b3;
    box-shadow:0 0 0 3px rgba(255,196,52,.22);
  }
  
  /* Helpers */
  .filters-card .span-3 { grid-column: 2 / -1; }
  .filters-card .cell{ height:0; }
  .filters-card .span-4{ grid-column: 1 / -1; }
  .grayed-out{ background:#f5f5f5; color:#999; }
  .sub-brand-loading-grayed-out{ opacity:.6; }
  
  /* Button */
  .btn-submit-save{
    padding: 10px 14px; font-size: .95rem; border-radius: 10px;
    background:#FFC434; border:none; cursor:pointer; font-weight:600;
    box-shadow:0 2px 6px rgba(0,0,0,.08);
  }
  .btn-submit-save:hover{ background:#e6b12e; }
  
  /* Responsive */
  @media (max-width: 1200px){
    .filters-card { --ctrl-w: 300px; }
  }
  @media (max-width: 980px){
    .filters-card { --label-w: 150px; --ctrl-w: 1fr; }
    .filters-card .row { grid-template-columns: var(--label-w) 1fr; }
    .filters-card .sep, .filters-card .row > .cell { display: none; }
  }
  </style>
  
  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
import { showReportLoading, hideReportLoading } from '@/utils/reportLoading';
  
  export default {
    data() {
      return {
        lotStartDateStart: '',
        lotStartDateEnd: '',
        lotEndDateStart: '',
        lotEndDateEnd: '',
        noteNumberStart: '',
        noteNumberEnd: '',
        sucursal: '',
        lot: '',
        fileNumber: '',
        vehiclePlates: '',
        vehicleColor: '',
        lotAuthority: '',
        SelectedBrand: '',
        SelectedSubBrand: '',
        brands: {},        // { brandName: brandPk }
        sub_brands: {},    // { subLabel: subId }
        subBrandLoading: false,
        blockEdit: false,
        isGeneratingReport: false,
      };
    },
  
    computed: {
      effectiveEndDateStart() {
        return this.lotStartDateEnd || this.lotStartDateStart;
      },
      effectiveEndDateEnd() {
        return this.lotEndDateEnd || this.lotEndDateStart;
      },
    },
  
    methods: {
      formatToDatetime(date, time) {
        if (!date) return '';
        return `${date}T${time}`;
      },
      backMainPanel() {
        window.location.href = '/main-panel';
      },
  
      async FetchBrands() {
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const { data } = await axios.get(`${apiDirectory}/get-brands`);
          const brandsDict = {};
          // map to {brandName: pk}
          data.forEach(b => { brandsDict[b.brand] = b.pk; });
          this.brands = brandsDict;
        } catch (error) {
          console.error("Failed to fetch brands", error);
          const status = error?.response?.status;
          if (status === 400) {
            Swal.fire('Error', 'Hubo un problema con la solicitud. Inténtalo nuevamente.\nSi el problema persiste, contacte a su administrador.', 'error');
          } else {
            Swal.fire('Error', 'Ocurrió un error desconocido. Inténtalo nuevamente.\nSi el problema persiste, contacte a su administrador.', 'error');
          }
        }
      },
  
      async FetchFilteredSubBrands(event){
        this.subBrandLoading = true;
        const selectedBrandPk = event.target.value;
        // reset selected subbrand if brand changed
        if (selectedBrandPk !== this.SelectedBrand) this.SelectedSubBrand = null;
  
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const { data } = await axios.post(`${apiDirectory}/get-filtered-sub-brands`, { brand_id: selectedBrandPk });
          const subBrandsDict = {};
          const classes = {1:'A', 2:'B', 3:'C', 4:'D'};
          data.forEach(sb => {
            subBrandsDict[`${sb.sub_brand} -- Clase: ${classes[sb.required_unit_type]}`] = sb.id;
          });
          this.sub_brands = subBrandsDict;
        } catch (error) {
          console.error("Failed to fetch sub-brands", error);
          const status = error?.response?.status;
          if (status === 400) {
            Swal.fire('Error', 'Hubo un problema con la solicitud. Inténtalo nuevamente.\nSi el problema persiste, contacte a su administrador.', 'error');
          } else {
            Swal.fire('Error', 'Ocurrió un error desconocido. Inténtalo nuevamente.\nSi el problema persiste, contacte a su administrador.', 'error');
          }
        } finally {
          this.subBrandLoading = false;
        }
      },
  
      validateNoteNumbers() {
        if (this.noteNumberStart !== '' && this.noteNumberEnd === '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'Debe ingresar un número de orden final cuando ingresa un número inicial' });
          return false;
        }
        if (this.noteNumberStart === '' && this.noteNumberEnd !== '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'No puede ingresar un número de orden final sin un número inicial' });
          return false;
        }
        if (this.noteNumberStart !== '' && this.noteNumberEnd !== '') {
          const a = parseInt(this.noteNumberStart, 10);
          const b = parseInt(this.noteNumberEnd, 10);
          if (Number.isFinite(a) && Number.isFinite(b) && b < a) {
            Swal.fire({ icon:'error', title:'Error de validación', text:'El número de orden final debe ser mayor o igual al número de orden inicial' });
            return false;
          }
        }
        return true;
      },
  
      async generateReport() {
        if (this.isGeneratingReport) return;
        if (!this.validateNoteNumbers()) return;
  
        const payload = {
          lot_start_time_start: this.formatToDatetime(this.lotStartDateStart, '00:00'),
          lot_start_time_end:   this.formatToDatetime(this.effectiveEndDateStart, '23:59'),
          lot_end_time_start:   this.formatToDatetime(this.lotEndDateStart, '00:00'),
          lot_end_time_end:     this.formatToDatetime(this.effectiveEndDateEnd, '23:59'),
          note_number_start: this.noteNumberStart,
          note_number_end: this.noteNumberEnd,
          sucursal: this.sucursal,
          file_number: this.fileNumber,
          vehicle_plates: this.vehiclePlates,
          lot: this.lot,
          lot_authority: this.lotAuthority,
          vehicle_brand: this.SelectedBrand || '',
          vehicle_subbrand: this.SelectedSubBrand || '',
          vehicle_color: this.vehicleColor,
        };
  
        this.isGeneratingReport = true;
        showReportLoading();

        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.post(`${apiDirectory}/reports/report-lot-arrivals`, payload, {
            responseType: 'blob',
          });
  
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte_entradas_de_lote.zip');
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          const errorMessage = error?.response?.data?.error || error.message;
          Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage });
        } finally {
          this.isGeneratingReport = false;
          hideReportLoading();
        }
      },
  
      handleSubmit() {
        this.generateReport();
      },
    },
  
    mounted() {
      this.FetchBrands();
    },
  };
  </script>
  